import { render, staticRenderFns } from "./transportOrderList.vue?vue&type=template&id=250bdb84"
import script from "./transportOrderList.vue?vue&type=script&lang=js"
export * from "./transportOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports